var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceceilingsimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000098218600079469709420000011288175109811164578_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 876.2 300.9",
    style: {
      enableBackground: "new 0 0 876.2 300.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.91;fill:#A3CFD9;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#006D7F;}\n\t.st3{fill:#043E4B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.2,
    y: 0.2,
    className: "st0",
    width: 686.4,
    height: 192.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.4,
    y: -260,
    transform: "matrix(0.2565 -0.9666 0.9666 0.2565 231.9934 494.4669)",
    className: "st1",
    width: 10,
    height: 712.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 91.6,
    transform: "matrix(0.9662 -0.2576 0.2576 0.9662 -10.1156 116.1571)",
    className: "st1",
    width: 712.9,
    height: 10.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.6,101.3h-12v-6h12V101.3z M398.6,101.3h-12v-6h12V101.3z M374.6,101.3h-12v-6h12V101.3z M350.6,101.3h-12 v-6h12V101.3z M326.6,101.3h-12v-6h12V101.3z M302.6,101.3h-12v-6h12V101.3z M278.6,101.3h-12v-6h12V101.3z M254.6,101.3h-12v-6h12 V101.3z M230.6,101.3h-12v-6h12V101.3z M206.6,101.3h-12v-6h12V101.3z M182.6,101.3h-12v-6h12V101.3z M158.6,101.3h-12v-6h12V101.3 z M134.6,101.3h-12v-6h12V101.3z M110.6,101.3h-12v-6h12V101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M866.8,150.2H9.5c-5.2,0-9.5-4.2-9.5-9.5s4.2-9.5,9.5-9.5h857.2c5.2,0,9.5,4.2,9.5,9.5S872,150.2,866.8,150.2z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 428.7,
    y: 219.9,
    className: "st3",
    width: 20,
    height: 73.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "487.5,234.2 438.7,149.6 389.8,234.2  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceceilingsimage);
export default __webpack_public_path__ + "static/media/Price ceilings image.7b66bf88222975099d96117a729c364b.svg";
export { ForwardRef as ReactComponent };